export default "__VITE_ASSET__a1644558__"